module.exports = __webpack_public_path__ + "static/media/pie-chart-borough.a62624de.svg";